import React, { useCallback, useEffect, useState } from "react";
import Handler from "../../Helpers/Handler";
import { agoText } from "../StaffTracking/trackingShared";

const REFRESH_MS = 30000;

// "My location sharing": tells the staff member, in plain words, whether their
// position is being shared right now and why. The phone app does the sharing;
// this card only reports what the server is receiving.
const LocationShareCard = () => {
    const [status, setStatus] = useState(null);
    const [now, setNow] = useState(Date.now());

    const load = useCallback(async () => {
        const response = await Handler({ method: "GET", url: "/staff/location/status", silent: true });
        if (response?.success) setStatus(response?.data?.data || null);
        setNow(Date.now());
    }, []);

    useEffect(() => {
        load();
        const timer = setInterval(load, REFRESH_MS);
        return () => clearInterval(timer);
    }, [load]);

    if (!status) return null;

    const lastSeen = status.lastSharedAt ? agoText(status.lastSharedAt, now) : null;
    let tone = "";
    let title;
    let sub;
    if (!status.trackingEnabled) {
        title = "Location sharing is switched off for you";
        sub = "Your supervisor turned it off. Ask them if you think this is a mistake.";
    } else if (!status.sharing) {
        title = "Not sharing - you are off shift";
        sub = "Your location is shared only from check-in to check-out, and while you are on a delivery or pick-up.";
    } else if (status.activeTaskId) {
        tone = lastSeen ? "on" : "warn";
        title = `Sharing on task ${status.activeTaskId}`;
        sub = lastSeen ? `Last position received ${lastSeen}.` : "Waiting for the first position from your phone. Open the staff app and allow location.";
    } else {
        tone = lastSeen ? "on" : "warn";
        title = "Sharing during your shift";
        sub = lastSeen ? `Last position received ${lastSeen}.` : "Waiting for the first position from your phone. Open the staff app and allow location.";
    }

    return (
        <div className="st-share" role="status">
            <span className={`st-share-dot ${tone}`} />
            <div className="st-share-text">
                <div className="st-share-title">{title}</div>
                <div className="st-share-sub">{sub}</div>
            </div>
            <div className="st-share-sub">Locations are kept for {status.retentionDays} days.</div>
        </div>
    );
};

export default LocationShareCard;
